import React, { type FC } from 'react'
import { Drawer, Tabs, type TabsProps } from 'antd'

import { type IUserPermission } from '../../../constants/types/common'
import { type IOktaUser } from '../../../constants/types/generatedTypesAliases'
import { UsersAvatarBlock, DrawerFooterBlock, CloseDrawerButton } from '../../shared'
import { UserDetailsPermissions, UserDetailsOverview } from '../'

interface IUserDetailsPanelProps {
  permissions: IUserPermission[]
  permissionsLoading: boolean
  selectedUser: IOktaUser
  closeDrawer: () => void
  activeKey: string
  setActiveKey: (key: string) => void
}

export const UserDetailsPanel: FC<IUserDetailsPanelProps> = ({
  permissions,
  permissionsLoading,
  selectedUser,
  closeDrawer,
  activeKey,
  setActiveKey,
}) => {
  const items: TabsProps['items'] = [
    {
      key: '1',
      label: 'Overview',
      children: (
        <UserDetailsOverview
          selectedUser={selectedUser} />
      )
    },
    {
      key: '2',
      label: `Permissions (${permissions.length})`,
      children: (
        <UserDetailsPermissions
          selectedUser={selectedUser}
          permissions={permissions}
          loading={permissionsLoading} />
      )
    }
  ]

  if (!selectedUser) return null

  return (
    <Drawer
      title='User Details'
      rootClassName='permission-manager'
      data-testid='user-operation-drawer'
      closable={false}
      extra={(
        <CloseDrawerButton onCloseDrawer={closeDrawer} />
      )}
      onClose={closeDrawer}
      open={Boolean(selectedUser)}
      push={false}
      footer={(
        <DrawerFooterBlock confirm={{
          onClick: closeDrawer
        }} />
      )}
      classNames={{
        header: 'drawer-header',
        body: 'user-details__drawer-body'
      }}
      width='60%'>
      <UsersAvatarBlock users={[selectedUser]} />
      <Tabs
        items={items}
        className='user-details__tabs'
        onTabClick={(key) => setActiveKey(key)}
        activeKey={activeKey} />
    </Drawer>
  )
}
